module.exports = __webpack_public_path__ + "img/OT166.e5f92b1.webp";